

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import Layout from '../components/Layout/Layout';
// import UserMenu from '../components/Layout/UserMenu';

// const Orders = () => {
//   const [orders, setOrders] = useState([]);

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const response = await axios.get('https://bablu-server.onrender.com/auth/orders');
//         setOrders(response.data.orders);
//       } catch (error) {
//         console.log(error);
//       }
//     };

//     fetchOrders();
//   }, []);

//   return (
//     <Layout>
//       <div className="row container-fluid">
//         <div className="col-12 col-sm-12 col-md-3">
// <UserMenu/>
//         </div>
//         <div className="col-12 col-sm-12 col-md-9">
//         <h2>All Orders</h2>
//       <table className='table'>
//         <thead>
//           <tr>
//             {/* <th>Order ID</th> */}
//             <th>#</th>
//             <th>Status</th>
//             <th>Buyer</th>
//             <th>Payment</th>
//             <th>Products</th>
//           </tr>
//         </thead>
//         <tbody>
//           {orders.map((order,i) => (
//             <tr key={order._id}>
//               <td>{i+1}</td>
//               {/* <td>{order._id}</td> */}
//               <td>{order.status}</td>
//               <td>{order.buyer ? order.buyer.name : 'N/A'}</td>
//               <td>{order.payment}</td>
//               <td>
// <ul>
//   {order.products.map((product) => (
//     <li key={product._id}>
//       <div>
//       <img src={`https://bablu-server.onrender.com/api/product-photo/${product._id}`} alt={product.name} height='200px' width='200px' />
//       </div>
//       <div>
//         <p>Name: {product.name ? product.name : 'N/A'}</p>
//         <p>Price: {product.price ? product.price : 'N/A'}</p>
//         <p>Price: {product.description ? product.description : 'N/A'}</p>
//       </div>
//     </li>
//   ))}
// </ul>
// </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//         </div>
//       </div>
      
//     </Layout>
//   );
// };

// export default Orders;




import React, { useState, useEffect } from "react";
import UserMenu from "../components/Layout/UserMenu";
import Layout from "../components/Layout/Layout";
import axios from "axios";
import { useAuth } from "../context/auth";
import moment from "moment";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [auth, setAuth] = useAuth();
  const getOrders = async () => {
    try {
      const response = await axios.get("https://bablu-server.onrender.com/auth/orders");
      setOrders(response.data.orders);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (auth?.token) getOrders();
  }, [auth?.token]);
  return (
    <Layout title={"Your Orders"}>
      <div className=" p-3 m-3 dashboard">
        <div className="row container-fluid">
          <div className="col-md-3">
            <UserMenu />
          </div>
          <div className="col-md-9">
            <h1 className="text-center">All Orders</h1>
            {orders?.map((o, i) => {
              return (
                <div className="border shadow">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Status</th>
                        <th scope="col">Buyer</th>
                        <th scope="col"> date</th>
                        <th scope="col">Payment</th>
                        <th scope="col">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{i + 1}</td>
                        <td>{o?.status}</td>
                        <td>{o.buyer ? o.buyer.name : 'N/A'}</td>
                        <td>{moment(o?.createAt).fromNow()}</td>
                        <td>{o?.payment}</td>
                        <td>{o?.products?.length}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="container-fluid">
                    {o?.products?.map((p, i) => (
                      <div className="row container-fluid mb-2 p-3 card flex-row" key={p._id}>
                        <div className="col-md-4">
                          <img
                            src={`https://bablu-server.onrender.com/api/product-photo/${p._id}`}
                            className="card-img-top"
                            alt={p.name}
                            width="100px"
                            height={"100px"}
                          />
                        </div>
                        <div className="col-md-8">
                          <p>{p.name}</p>
                          <p>{p.description.substring(0, 30)}</p>
                          <p>Price : {p.price}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Orders;